import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { CalendarModule } from 'primeng/calendar';
import { TabViewModule } from 'primeng/tabview';
import { TabMenuModule } from 'primeng/tabmenu';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { MenuModule } from 'primeng/menu';
import { ContextMenuModule } from 'primeng/contextmenu';
import { MenubarModule } from 'primeng/menubar';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { TableModule } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SidebarModule } from 'primeng/sidebar';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { BadgeModule } from 'primeng/badge';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RadioButtonModule } from 'primeng/radiobutton';
import { PanelMenuModule } from "primeng/panelmenu";
import { OverlayPanelModule } from "primeng/overlaypanel";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ButtonModule,
    ToastModule,
    CalendarModule,
    TabViewModule,
    TabMenuModule,
    DropdownModule,
    MultiSelectModule,
    MenuModule ,
    ContextMenuModule,
    MenubarModule,
    DynamicDialogModule,
    TableModule,
    ProgressSpinnerModule,
    SidebarModule,
    InputTextareaModule,
    BadgeModule,
    InputSwitchModule,
    RadioButtonModule,
    PanelMenuModule,
    OverlayPanelModule,
  ],
  exports: [
    ButtonModule,
    ToastModule,
    CalendarModule,
    TabViewModule,
    TabMenuModule,
    DropdownModule,
    MultiSelectModule,
    MenuModule,
    ContextMenuModule,
    MenubarModule,
    DynamicDialogModule,
    TableModule,
    ProgressSpinnerModule,
    SidebarModule,
    InputTextareaModule,
    BadgeModule,
    InputSwitchModule,
    RadioButtonModule,
    PanelMenuModule,
    OverlayPanelModule,
  ],
  providers: [MessageService]
})
export class PrimeNgModule {}
